module.exports = __webpack_public_path__ + "fcb03413115e9ce244e34e8ed6315d6b.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-account/groups-apps/remove-from-group/remove-account-from-group.html
// module id = 1991
// module chunks = 0